import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b7f5073"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container mt-4" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Zresetuj hasło", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Podaj swoje nowe hasło.", -1))
const _hoisted_5 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_6 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_7 = {
  key: 1,
  class: "mb-2"
}
const _hoisted_8 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_9 = { class: "error mb-2" }
const _hoisted_10 = {
  key: 1,
  class: "error mb-2"
}
const _hoisted_11 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      (!_ctx.isPasswordReset)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.passwordError }]),
              placeholder: "Hasło",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event)),
              type: "password"
            }, null, 2), [
              [_vModelText, _ctx.password]
            ]),
            (_ctx.passwordError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.passwordError), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isPasswordReset)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.repeatPasswordError }]),
              placeholder: "Powtórz hasło",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.repeatPassword) = $event)),
              type: "password"
            }, null, 2), [
              [_vModelText, _ctx.repeatPassword]
            ]),
            (_ctx.repeatPasswordError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.repeatPasswordError), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.nonFieldErrors), 1),
            (_ctx.globalError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.globalError), 1))
              : _createCommentVNode("", true),
            (!_ctx.isPasswordReset)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "btn btn-gradient mt-2",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleResetPassword && _ctx.handleResetPassword(...args)))
                }, " Zresetuj hasło "))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isPasswordReset)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Twoje hasło zostało zresetowane, jesteś teraz zalogowany. "))
        : _createCommentVNode("", true)
    ])
  ]))
}